import React from 'react';

import { Breakpoints, useIsMobile } from '@vw-marketing/us-components';

import { applyTextTransformations } from '../../../../shared/utils/applyTextTransformations';
import { StyledDeactiveAccountCTA } from './styled';

interface DeactivateAccountCTAProps {
  defaultLabel: string;
  mobileLabel: string;
  disabled: boolean;
}

export const DeactivateAccountCTA: React.FC<DeactivateAccountCTAProps> = ({
  defaultLabel,
  mobileLabel,
  disabled
}) => {
  const isMobile = useIsMobile(Breakpoints.b560);

  const formatDefaultLabel = applyTextTransformations(defaultLabel, ['myVW']);

  return (
    <StyledDeactiveAccountCTA
      emphasis='tertiary'
      tag='button'
      disabled={disabled}
    >
      {isMobile ? mobileLabel : formatDefaultLabel}
    </StyledDeactiveAccountCTA>
  );
};